import { Radio as MuiRadio } from '@mui/material';
import { FunctionComponent } from 'react';

import { RadioProps } from './Radio.types';

const RadioButton: FunctionComponent<RadioProps> = (
  props: RadioProps
): JSX.Element => <MuiRadio {...props} />;

RadioButton.defaultProps = {
  color: 'primary',
};

export default RadioButton;
